import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { Message, MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { FilledButtonComponent } from '../../shared/buttons/filled-button/filled-button.component';
import { AsyncPipe, CommonModule, NgIf } from '@angular/common';
import { UIResultCommandInterface } from '@nts/std/interfaces';

@Component({
  selector: 'nts-toast-message',
  templateUrl: './toast-message.component.html',
  styleUrls: ['./toast-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ToastModule,
    SvgIconComponent,
    FilledButtonComponent,
    NgIf,
    CommonModule,
    AsyncPipe
  ]
})
export class ToastMessageComponent {

  constructor(
    private messageService: MessageService,
  ) {

  }

  async onCommandExecute(message: Message, key: string, commandData: { command: UIResultCommandInterface<any>, data: any; }) {
    let result = commandData.command.execute(commandData.data);
    if (result instanceof Promise) {
      // se il comando è async, aspetta il completamento
      result = await result;
    }
    message.data.toastResult?.next({ result, cancelled: false });
    this.messageService.clear(key);
  }

  // TODO fare porting alla versione con i comandi
  onConfirmUpdate(message: Message, key: string) {
    message.data.confirmEvent?.next(message);
    this.messageService.clear(key);
  }

  onReject(key: string) {
    this.messageService.clear(key);
  }
}
